export function formatDecimalString(value, minimumFractionDigits = 0) {
  if (value === null || value === undefined || value === '') {
    return '–'
  }

  const match = String(value).match(/^(-?)(\d+)(?:\.(\d+))?$/)
  if (!match) {
    return String(value)
  }

  const sign = match[1]
  const integer = match[2].replace(/^0+(?=\d)/, '')
  const groupedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  let fraction = match[3] || ''

  while (fraction.length > minimumFractionDigits && fraction.endsWith('0')) {
    fraction = fraction.slice(0, -1)
  }
  fraction = fraction.padEnd(minimumFractionDigits, '0')

  return `${sign}${groupedInteger}${fraction ? ',' + fraction : ''}`
}

export function formatMoney(value) {
  const formatted = formatDecimalString(value, 2)
  return formatted === '–' ? formatted : `${formatted} €`
}

export function formatQuantity(value) {
  return formatDecimalString(value, 0)
}

export function compareDecimalStrings(first, second) {
  const firstDecimal = normalizeDecimal(first)
  const secondDecimal = normalizeDecimal(second)

  if (!firstDecimal || !secondDecimal) {
    return String(first === null || first === undefined ? '' : first)
      .localeCompare(String(second === null || second === undefined ? '' : second), 'de-DE')
  }

  if (firstDecimal.negative !== secondDecimal.negative) {
    return firstDecimal.negative ? -1 : 1
  }

  const direction = firstDecimal.negative ? -1 : 1
  if (firstDecimal.integer.length !== secondDecimal.integer.length) {
    return (firstDecimal.integer.length > secondDecimal.integer.length ? 1 : -1) * direction
  }
  if (firstDecimal.integer !== secondDecimal.integer) {
    return (firstDecimal.integer > secondDecimal.integer ? 1 : -1) * direction
  }

  const fractionLength = Math.max(firstDecimal.fraction.length, secondDecimal.fraction.length)
  const firstFraction = firstDecimal.fraction.padEnd(fractionLength, '0')
  const secondFraction = secondDecimal.fraction.padEnd(fractionLength, '0')
  if (firstFraction === secondFraction) {
    return 0
  }
  return (firstFraction > secondFraction ? 1 : -1) * direction
}

function normalizeDecimal(value) {
  if (value === null || value === undefined || value === '') {
    return null
  }

  const match = String(value).match(/^(-?)(\d+)(?:\.(\d+))?$/)
  if (!match) {
    return null
  }

  const integer = match[2].replace(/^0+(?=\d)/, '')
  const fraction = (match[3] || '').replace(/0+$/, '')
  const isZero = integer === '0' && fraction === ''

  return {
    negative: match[1] === '-' && !isZero,
    integer,
    fraction
  }
}
